
























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';

@Component
export default class App extends Vue {
  private isCollapse: boolean = localStorage.getItem('isCollapse') === 'true';

  @State private node!: string;
  @State private solrMode!: string;
  @Action private loadCollections!: () => void;

  created() {
    this.loadCollections();
  }

  private openUrl(url: string) {
    window.open(url, '_blank');
  }

  private back2LegacyUI() {
    const segments = /.+:(\d+).*/.exec(this.node);
    const port = segments && segments.length > 1 ? segments[1] : '80';
    const host = window.location.host.includes(':') ? window.location.host.replace(/:.*/, '') : window.location.host;
    window.location.href = `http://${host}:${port}`;
  }

  @Watch('isCollapse')
  onIsCollapseChanged() {
    localStorage.setItem('isCollapse', this.isCollapse.toString());
  }

  get activeNav() {
    const segments = this.$route.path.match(/^(\/[^/]+).*/);
    const firstSegment = segments && segments[1];
    if (firstSegment && ['/cloud'].includes(firstSegment)) {
      return this.$route.path;
    }
    return firstSegment;
  }
}
